import { createReducer } from '../../../../store.model';

import { ActionType } from './main.action';
import { defaultState, MainState } from './main.state';
import { ExpandRow, ExpandRowResult } from './state/expand-row.action';
import {
    expandRowReducer,
    expandRowResultReducer,
} from './state/expand-row.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { SortRows } from './state/sort-rows.action';
import { sortRowsReducer } from './state/sort-rows.reducer';

const { reducer, builder } = createReducer<ActionType, MainState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.WP_MAIN__RELOAD, reloadReducer)
    .add<ReloadResult>(ActionType.WP_MAIN__RELOAD_RESULT, reloadResultReducer);

builder
    .add<ExpandRow>(ActionType.WP_MAIN__EXPAND_ROW, expandRowReducer)
    .add<ExpandRowResult>(
        ActionType.WP_MAIN__EXPAND_ROW_RESULT,
        expandRowResultReducer,
    );

builder.add<SortRows>(ActionType.WP_MAIN__SORT_ROWS, sortRowsReducer);

export const mainReducer = reducer;
